var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortArrowDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "7px",
    viewBox: "0 0 8 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People",
    transform: "translate(-226.000000, -129.000000)",
    fill: "#303F47",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-10",
    transform: "translate(230.000000, 132.500000) scale(1, -1) translate(-230.000000, -132.500000) translate(226.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97866667,0.085 C7.94933333,0.0326666667 7.89333333,-2.84217094e-13 7.83333333,-2.84217094e-13 L0.166666667,-2.84217094e-13 C0.106666667,-2.84217094e-13 0.051,0.0326666667 0.0216666667,0.085 C-0.00833333333,0.137333333 -0.00666666667,0.201666667 0.0243333333,0.253 L3.85766667,6.58633333 C3.88766667,6.63566667 3.942,6.66633333 4,6.66633333 C4.058,6.66633333 4.11233333,6.63566667 4.14266667,6.58633333 L7.976,0.253 C8.007,0.201 8.00833333,0.137 7.97866667,0.0846666667 L7.97866667,0.085 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowDark);
export default __webpack_public_path__ + "static/media/sort-arrow-dark.4c8f1408b5680f61567750ae366b0e6d.svg";
export { ForwardRef as ReactComponent };